import { BrowserRouter as Router, Routes, Route } from 'react-router-dom';
import Homepage from './components/Homepage';
import Gallery from './components/Gallery';
import InquiryForm from './components/InquiryForm';
import Quotation from './components/Quotation';
import LoginPage from './cms/LoginPage';
import Dashboard from './cms/Dashboard';
import { useState } from 'react';
import Footer from './components/Footer';  // Import Footer component

function App() {
  const [isLoggedIn, setIsLoggedIn] = useState(false); // State to track login status

  return (
    <Router>
      <div className="flex flex-col min-h-screen">
        <Routes>
          {/* Public Routes */}
          <Route path="/" element={<Homepage />} />
          <Route path="/gallery" element={<Gallery />} />
          <Route path="/inquiry" element={<InquiryForm />} />
          <Route path="/quotation" element={<Quotation />} />

          {/* CMS Routes */}
          <Route
            path="/login"
            element={<LoginPage onLogin={setIsLoggedIn} />}
          />
          <Route
            path="/dashboard"
            element={isLoggedIn ? <Dashboard /> : <LoginPage onLogin={setIsLoggedIn(true)} />}
          />
        </Routes>

        {/* Footer */}
        <Footer />
      </div>
    </Router>
  );
}

export default App;
